import cn from "classnames";
import { FC, useCallback } from "react";
import { isMobile } from "react-device-detect";
import { Trans } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { maskString } from "../../../../helpers/helpers";
import { racesLeaderboardLoader, requestRacesLeaderboard } from "../../../../store/actionCreators/racesLeaderboard";
import { getRacePrizeList, getRacesLeaderboard } from "../../../../store/selectors";
import { racePlayers, rankImages } from "../../../../utils/constants";
import { Virtuoso } from "react-virtuoso";

import "./styles.scss";


const headers = ["rank", "nameTeam", "score", "prize"];

interface LeaderBoardProps {
    selectedRaceTab: Record<string, string | number>;
    offset: number;
    setOffset: (st: (prevOffset: number) => number) => void
}

const LeaderBoard: FC<LeaderBoardProps> = ({ selectedRaceTab, offset, setOffset  }) => {
    const dispatch = useDispatch();

    const { data, isLoading } = useSelector(getRacesLeaderboard);
    const leaderboardPrizeList = useSelector(getRacePrizeList);
    const limit = 40
    

    const handleShowMore = useCallback(() => {
        if (data?.length >= limit) {
            dispatch(racesLeaderboardLoader());
            dispatch(requestRacesLeaderboard(limit, offset + 40, +selectedRaceTab?.id));
            setOffset((prevOffset: number) => prevOffset + limit);
        }
    }, [data?.length, limit, offset, selectedRaceTab?.id]);


    const classes = cn("leaderboard", {
        "leaderboard--mobile": isMobile,
    });

    const getParents = (parents: number[]): string => {
        const matchedPlayers = racePlayers?.find(player => parents?.includes(player.id));
        return matchedPlayers?.name ? matchedPlayers?.name : "Papionline";
    }

    return data?.length ? (
        <>
            {isLoading && <div className="loader-container">
                <div className="custom-spinner"></div>
            </div> }
            <div className={classes}>
                <div className="leaderboard__header">
                    {headers.map((item) => (
                        <div key={item} className="leaderboard__header__item">
                            <Trans i18nKey={item} components={[<br />]} />
                        </div>
                    ))}
                </div>
                <div className={cn('leaderboard__body')}>
                    <Virtuoso
                        className={cn('table__body-inner')}
                        data={data}
                        endReached={handleShowMore}
                        itemContent={(index, player) =>  {
                            return (
                                <>
                                    <div
                                        key={index}
                                        className={cn("leaderboard__body__row", {
                                            even: index % 2 === 0,
                                            odd: index % 2 !== 0,
                                        })}
                                    >
                                        <div className="leaderboard__item__rank">
                                            {player?.rank in rankImages ? (
                                                <img width={31} src={rankImages[player?.rank]} alt={rankImages[player?.rank]} />
                                            ) : (
                                                <span>{player?.rank}</span>
                                            )}
                                        </div>
                                        <div>
                                            <p>{maskString(player.username)}</p>
                                            <p>{getParents(player?.parents)}</p>
                                        </div>
                                        <div>{player?.points}</div>
                                        <div>{leaderboardPrizeList[player?.rank] || ""}</div>
                                    </div>
                                </>
                            );
                        }}
                    />
                </div>
            </div>
        </>
    ) : (
        <></>
    );
};

export default LeaderBoard;
